import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-118" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-119" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-3xl uppercase tracking-wide text-gold" data-id="element-120" data-mp="3ghc2o28413o8">
          Softball Season-Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-121" data-mp="36p6df098t0cq">
          The 4-Block Practice System — so you walk onto the field knowing
          exactly what to run, even if it&apos;s your first season.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-122" data-mp="38zbozae1d6l">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-123" data-mp="3ldamrdmenziu">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-124" data-mp="29yxbr9cr3ek8">
          Softball Season-Ready is an educational resource for coaches. It does
          not replace coach certification, CPR/first-aid training, or the rules
          of your league or governing body; rules and field dimensions vary by
          league. Coaches are responsible for making sure any drill or skill is
          supervised, age-appropriate and safe for their players before it is
          run. Not affiliated with or endorsed by USA Softball, NFHS, Little
          League or any other organization.
          &copy; Softball Season-Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}